import * as actions from '../../actions'
import * as storage from '../../../utils/storage'

const defaultState = null

export default function nlpSelected(state = defaultState, action) {
    switch (action.type) {
        case actions.SELECT_NLP_MODULE:
            if (action.payload && action.payload !== state) {
                state = action.payload
                if (state && state.language) {
                    storage.set('nlpSelected', state.language)
                }
            }
            return state

        case actions.CLEAN_ALL:
        case actions.APP_SELECT:
            storage.remove('nlpSelected')
            return defaultState

        default:
            return state
    }
}
